import React from 'react';
import { HashRouter as Router, Redirect } from 'react-router-dom';
import Login from './Login';
import Header from './Header';
import { Trans } from 'react-i18next';

import { Container, Image, Col, Row, Button } from 'react-bootstrap';
import { X_API_KEY, isAuthenticated } from '../../utils/authentication';

export const AppTitle = "Tuner4TRONIC";

export default class App extends React.Component {

    onHelp() {

        let url = `${window.location.origin}/docu/index.html`;

        var win = window.open(url, '_blank');
        win.focus();
    }

    render() {

        document.title = AppTitle;

        const parameters = new URLSearchParams(this.props.location.search);
        const brand = parameters.get('brand');

        if (brand && localStorage.getItem(X_API_KEY) === ''){
            localStorage.removeItem(X_API_KEY);
            return (<Redirect to={`/login?force=1&brand=${brand}`} />);
        }

        if (isAuthenticated()) {
            return (<Redirect to='/' />);
        }

        return (
            <Router>
                <div>
                    <Header brand={brand}/>
                </div>
                <div className="content">
                    <Container fluid="true" className="internal-content">
                        <Row style={{ height: '90vh', overflow: 'hidden' }}>
                            <Col sm={2} ></Col>
                            <Col sm={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                                <Login />
                            </Col>
                            <Col sm={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                                <div style={{ maxWidth: '90vh' }}>
                                    <Row>
                                        <Col style={{ display: 'flex'}}>
                                            <Image src="./images/T4T.png" style={{ maxWidth: '50%', height: 'auto', margin: '0 auto' }} />
                                        </Col>
                                    </Row>
                                    {/* <Row>
                                        <Col style={{ maxWidth: '50%', height: 'auto' }}>
                                            <div className="minimuSystemRequirements">
                                                Minimum system requirements: Google Chrome or Mozilla Firefox
                                                <br />
                                                (We do not recommend Internet Explorer)
                                                <br />
                                                Minimum screen resolution: 1366x768px
                                            </div>
                                        </Col>
                                    </Row> */}
                                    <Row>
                                        <Col style={{ height: 'auto', textAlign: 'center', margin: '1rem auto' }}>
                                            <Button className="btn-landing" variant="secondary" type="button" onClick={this.onHelp}>
                                                <Trans i18nKey="Help" />
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col sm={2} ></Col>
                        </Row>
                        <Row style={{ height: '4vh' }}>
                            <Col sm={10} style={{ display: 'flex', alignItems: 'center' }}>
                                <div className="loginFooter" style={{ paddingLeft: '25px' }}>&copy;{( new Date().getFullYear() )}, INVENTRONICS GmbH. All rights reserved. </div>
                                <a rel="noopener noreferrer" className="loginFooter" href={`${window.location.protocol}//${window.location.hostname}/imprint.html`} target="_blank" style={{ paddingLeft: '25px' }}><Trans i18nKey="Imprint" /></a>
                                <a rel="noopener noreferrer" className="loginFooter" href={`${window.location.protocol}//${window.location.hostname}/terms.html`} target="_blank" style={{ paddingLeft: '25px' }}><Trans i18nKey="Terms_of_Use" /></a>
                                <a rel="noopener noreferrer" className="loginFooter" href={`${window.location.protocol}//${window.location.hostname}/privacy.html`} target="_blank" style={{ paddingLeft: '25px' }}><Trans i18nKey="Privacy_Policy" /></a>
                                <a rel="noopener noreferrer" className="loginFooter" href={`${window.location.protocol}//${window.location.hostname}/oss.html`} target="_blank" style={{ paddingLeft: '25px' }}><Trans i18nKey="Open_Source_Licenses" /></a>
                                <a rel="noopener noreferrer" className="loginFooter" href="https://www.inventronics-light.com/contact-us" target="_blank" style={{ paddingLeft: '25px' }}><Trans i18nKey="Contacts" /></a>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </Router>
        );
    }
}
